export default __webpack_public_path__ + "static/media/insta.5f1a4875.png";